export const sanitiseInput = (inputTxt) => decodeURIComponent(encodeURIComponent(inputTxt))
